// src/api/axios.js
import axios from 'axios';
import { auth } from '../services/firebase';
import { FIREBASE_FUNCTIONS_URL } from '../config/environment';

const axiosInstance = axios.create({
  baseURL: FIREBASE_FUNCTIONS_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  timeout: 30000, // Increased timeout for Firebase Functions cold starts
  withCredentials: false, // Disable credentials to avoid CORS wildcard issues
});

// Request interceptor - Uses Firebase ID token
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const user = auth.currentUser;
      if (user) {
        // Get fresh Firebase ID token
        const token = await user.getIdToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      
      // Don't add CORS headers from client side - these are response headers
      
      console.log('🌐 Making request to:', config.url, 'with headers:', config.headers);
    } catch (error) {
      console.error('Error getting Firebase ID token:', error);
      // Continue with request even if token fetch fails
    }
    return config;
  },
  (error) => {
    console.error('❌ Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('✅ Response received:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ Response error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      message: error.message,
      data: error.response?.data
    });
    
    if (error.response && error.response.status === 401) {
      // Handle unauthorized error - could redirect to login
      console.warn('Received 401 Unauthorized response from Firebase Functions');
    } else if (error.code === 'ERR_NETWORK') {
      console.error('Network error - CORS or connectivity issue');
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
